'use strict'
class Newsletter {
    static init() {
        Newsletter.blocs = document.querySelectorAll(".footer__newsletter");

        Newsletter.blocs.forEach(n => {
            n.field = n.querySelector('.footer__newsletter__input');
            n.button = n.querySelector('.footer__newsletter__button');
            n.error = n.querySelector('.footer__newsletter__error');
            n.captcha = n.querySelector('.footer__newsletter__captcha');

            if (n.field && n.button && n.error) {
                // Pour gerer l'affichage du captcha (show)
                n.field.addEventListener('input', () => {
                    if (n.captcha) {
                        if (n.field.value.trim().length > 0) {
                            n.captcha.classList.add('show--');
                        } else {
                            n.captcha.classList.remove('show--');
                        }
                    }
                });

                n.button.addEventListener('click', e => Newsletter.handleSubmit(e, n));
            }
        })
    }

    static validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    }

    static handleSubmit(event, bloc) {
        event.preventDefault();
        const email = bloc.field.value.trim();

        if (!Newsletter.validateEmail(email)) {
            bloc.error.textContent = 'Please enter a valid email address.';
            return;
        }

        bloc.error.textContent = '';
        let captchaResponse = bloc.querySelector('.frc-captcha-solution')?.value;

        if (captchaResponse && captchaResponse !== ".UNFINISHED") {
            let bodyData = JSON.stringify({
                "newsletter_email": email,
                "frc-captcha-solution": captchaResponse
            })

            fetch('/wp-json/hadvisors/v1/subscribe-newsletter', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: bodyData
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        bloc.error.textContent += data.message;
                    } else {
                        if ("newsletter_email" in data.message) {
                            bloc.error.textContent += "Please enter a valid email address.";
                        }

                        if ("frc-captcha-solution" in data.message && !data.message["frc-captcha-solution"]) {
                            bloc.error.textContent += "Please validate the captcha.";
                        }
                        window.friendlyChallenge.autoWidget.reset()
                    }
                })
                .catch(error => {
                    bloc.error.textContent = 'Connection problem : ' + error.message;
                    window.friendlyChallenge.autoWidget.reset()
                });
        }
        else {
            bloc.error.textContent = 'The Captcha is not loaded. Please wait.';
        }
    }
}

export default Newsletter;
